import { BACKEND_URL } from "../../utils/config";
import { errorHandler } from "../../utils/error_handler";
import { getUserPermission } from "../../utils/getUserPermission";


export const setPhases = (phases) => ({
    type: "SET_PHASES",
    payload: {
        phases: phases,
    },
    request_time: Date.now()
});

export const setPhase = (data) => ({
    type: "SET_PHASE",
    payload: {
        id: data.id,
        identifier: data.identifier,
        description: data.description,
        name: data.name,
        required_checklist: data.required_checklist,
        position: data.position,
        request_time: Date.now()
    },
});

export const setPhasesError = (error) => ({
    type: "PHASE_ERROR",
    payload: {
        error: error
    }
});

export const deletePhase = (phase_id) => ({
    type: "DELETE_PHASE",
    payload: {
        id: phase_id,
    },
    request_time: Date.now()
});

export const getAllPhases = () => {

    return (dispatch, getState) => {
        const state = getState();
        try {
            if (!getUserPermission(state, "phases", "list", true)) {
                throw new Error("No permissions");
            }
            if (state.phases.request_time === null
                || state.phases.request_time + 1000 * 2 < Date.now()) {
                fetch(`${BACKEND_URL}/phases`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${state.sessions.token}`
                    },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            return response.json();
                        } else {
                            throw new Error(response.status);
                        }
                    })
                    .then((data) => {
                        dispatch(setPhases(data));
                    })
                    .catch((error) => {
                        errorHandler("phases", error.message);
                        dispatch(setPhasesError(error));
                    });
            }
        } catch (error) {
            errorHandler("phases", error.message);
            dispatch(setPhasesError(error));
        }
    };
}

export const postPhase = (data) => {
    return (dispatch, getState) => {
        const state = getState();
        try {
            if (!getUserPermission(state, "phases", "create", true)) {
                throw new Error("No permissions");
            }
            fetch(`${BACKEND_URL}/phases`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${state.sessions.token}`
                },
                body: JSON.stringify(data)
            })
                .then((response) => {
                    if (response.status === 201) {
                        return response.json();
                    } else {
                        throw new Error(response.status);
                    }
                })
                .then((data) => {
                    if (data != null && data !== undefined && data.id !== undefined) {
                        dispatch(setPhase(data));
                    }
                })
                .catch((error) => {
                    errorHandler("phases", error.message);
                    dispatch(setPhasesError(error));
                });
        } catch (error) {
            errorHandler("phases", error.message);
            dispatch(setPhasesError(error));
        }
    };
}

export const deletePhaseById = (phase_id) => {
    return (dispatch, getState) => {
        const state = getState();
        try {
            if (!getUserPermission(state, "phases", "delete", true)) {
                throw new Error("No permissions");
            }
            fetch(`${BACKEND_URL}/phases/${phase_id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${state.sessions.token}`
                },
            })
                .then((response) => {
                    if (response.status === 204) {
                        return true;
                    } else {
                        throw new Error(response.status);
                    }
                })
                .then((vl) => {
                    if (vl) {
                        dispatch(deletePhase(phase_id));
                    }
                })
                .catch((error) => {
                    errorHandler("phases", error.message);
                    dispatch(setPhasesError(error));
                });
        } catch (error) {
            errorHandler("phases", error.message);
            dispatch(setPhasesError(error));
        }
    };
}